<!--
 * @Descripttion:
 * @version:
 * @Author: shenlin
 * @Date: 2021-10-27 15:51:58
 * @LastEditors: shenlin
 * @LastEditTime: 2022-07-19 13:58:51
-->
<template>
  <div class="container">
    <section class="header">
      <div class="title">操作手册</div>
    </section>
    <section class="body">
      <ul>
        <li>上传中介超市应用相关的操作手册文档</li>
        <li>用户在中介超市可下载该文档进行查看</li>
      </ul>
      <div class="upload">
        已上传：
        <a :href="fileUrl" v-if="fileName">{{ fileName }}</a>
        <span v-else>-</span>
      </div>
      <div style="margin:30px">
        <span slot="footer" class="dialog-footer">
          <el-button type="primary" @click="importDialogVisible = true"
            >编 辑</el-button
          >
          <el-button @click="onDelete" :disabled="!this.id">删 除</el-button>
        </span>
      </div>
    </section>
    <el-dialog
      title="编辑"
      class="import-dialog"
      :destroy-on-close="true"
      :close-on-click-modal="false"
      :visible.sync="importDialogVisible"
      width="40%"
      :before-close="importDialogClose"
    >
      <div class="content-box">
        <div class="step-content">
          <div class="step-item">
            <div class="step-icon" v-show="importStep == 1">
              <i class="el-icon-check"></i>
            </div>
            <div class="step-icon unactive" v-show="importStep == 0">1</div>
            <span>上传模板</span>
          </div>
          <div class="step-line">
            <div class="line" :class="{ active: importStep == 1 }"></div>
          </div>
          <div class="step-item">
            <div class="step-icon unactive">2</div>
            <span>查看结果</span>
          </div>
        </div>
        <div class="content-temp">
          <div style="margin-bottom:20px">新上传的附件将会覆盖旧的附件</div>
          <import-temp
            ref="uploadTemp"
            @uploadOver="uploadOver"
            v-if="importStep == 0"
          />
          <div class="upload-finish" v-else>
            <div class="el-icon-check uploding-icon"></div>
            <div>文件上传成功</div>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="importDialogVisible = false" v-show="importStep == 0"
          >取 消</el-button
        >
        <el-button
          type="primary"
          @click="submitUpload"
          v-show="importStep == 0"
          :disabled="disabledClick"
          >提交</el-button
        >
        <el-button
          type="primary"
          @click="importDialogClose"
          v-show="importStep == 1"
          >关闭</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import importTemp from './components/importTemp.vue'
import {
  getOperation,
  insertOrUpdateOperation,
  deleteOperation
} from '@api/yardIntermediary/institutionalManagement'
export default {
  name: 'Management',
  data() {
    return {
      id: null,
      fileName: null,
      fileUrl: null,
      importDialogVisible: false,
      importStep: 0,
      disabledClick: false
    }
  },
  components: {
    'import-temp': importTemp
  },
  computed: {},
  created() {
    this.getOperation()
  },
  methods: {
    uploadOver(data) {
      let flag = data.type == 1
      if (flag && data.data.code == '0000') {
        this.fileName = data.data.data.fileName
        this.fileUrl = data.data.data.ossUrl
      } else {
        this.$message.error(data.data.msg)
      }
      this.disabledClick = false
    },
    insertOrUpdateOperation() {
      const data = {
        id: this.id,
        fileName: this.fileName,
        uploadUrl: this.fileUrl
      }
      insertOrUpdateOperation(data).then(res => {
        if (res.data.code == '0000') {
          this.importStep = 1
          // this.$message.success(res.data.msg)
          this.getOperation()
        } else {
          this.$message.error(res.data.msg)
        }
      })
    },
    importDialogClose() {
      this.importDialogVisible = false
      this.importStep = 0
    },
    getOperation() {
      getOperation().then(res => {
        if (res.data.code == '0000') {
          if (res.data.data.length) {
            this.id = res.data.data[0].id
            this.fileName = res.data.data[0].fileName
            this.fileUrl = res.data.data[0].uploadUrl
          } else {
            this.id = null
            this.fileName = null
            this.fileUrl = null
          }
        } else {
          this.$message.error(res.data.msg)
        }
      })
    },
    submitUpload() {
      if (this.disabledClick) return
      this.insertOrUpdateOperation()
      this.disabledClick = true
      // this.$refs.uploadTemp.submit()
    },
    onDelete() {
      this.$confirm('此操作将永久删除该文件, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          deleteOperation({ id: this.id }).then(res => {
            if (res.data.code == '0000') {
              this.$message.success(res.data.msg)
              this.getOperation()
            } else {
              this.$message.error(res.data.msg)
            }
          })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
    }
  }
}
</script>

<style lang="scss" scoped>
.container {
  width: 100%;
  background: white;
  .header {
    background: white;
    > .title {
      padding: 16px 21px;
      font-size: 16px;
      font-weight: 600;
      color: rgba(0, 0, 0, 0.85);
      border-bottom: 1px solid rgba(0, 0, 0, 0.08);
    }
  }
  .body {
    padding: 10px;
    color: rgba(0, 0, 0, 0.65);
    .upload {
      margin-top: 30px;
      padding: 0 25px;
      a {
        color: rgba(24, 144, 255, 1);
      }
    }
  }
  .import-dialog {
    /deep/.el-dialog__body {
      padding: 20px;
    }
    .content-box {
      width: 80%;
      margin: auto;
      .step-content {
        display: flex;
        height: 24px;
        line-height: 24px;
        color: rgba(0, 0, 0, 0.65);
        font-size: 14px;
        text-align: left;
        font-family: PingFangSC-Medium;
        justify-content: space-between;
        margin-bottom: 20px;
        .step-item {
          display: flex;
          .step-icon {
            width: 20px;
            height: 20px;
            border-radius: 50%;
            line-height: 20px;
            text-align: center;
            margin-top: 3px;
            border: 1px solid #1890ff;
            margin-right: 8px;
            background-color: white;
            color: #1890ff;
          }
          .unactive {
            background-color: #1890ff;
            color: white;
          }
          .active-info {
            color: #1890ff;
          }
        }
        .step-line {
          position: relative;
          flex: 1;
          .line {
            background-color: rgba(0, 0, 0, 0.1);
            height: 1px;
            position: absolute;
            left: 10px;
            right: 10px;
            top: 11px;
          }
          .active {
            background-color: #1890ff;
          }
        }
      }
      .content-temp {
        .upload-finish {
          text-align: center;
          .uploding-icon {
            border-radius: 50%;
            background-color: #1890ff;
            color: white;
            width: 100px;
            line-height: 100px;
            height: 100px;
            margin: 0 auto 20px;
            font-size: 40px;
          }
          .show-history {
            cursor: pointer;
          }
        }
      }
    }
  }
}
</style>
